Set.prototype.asArray = function <T>(): T[] {
	return Array.from(this.values());
};

export {};
